import { matchPath } from 'react-router-dom';
import { getAbsoluteNavigationPaths } from '../../utils/navigation';

const { cellboardSummaryPath, settingsPath } = getAbsoluteNavigationPaths();

/**
 * Routes on which the break-time announcement never opens.
 *
 * - Scoreboard: a central-command view summarizing many cells, so the app-wide cell selection is
 *   not what is on screen.
 * - Settings: where the user resets their break-display preferences. Reopening the full-screen
 *   announcement there would block the page they came to use; it shows again once they leave.
 */
const SUPPRESSED_ROUTE_PATTERNS = [cellboardSummaryPath, `${settingsPath}/*`];

/**
 * Whether the break-time announcement should stay closed for this URL.
 *
 * Matched on the URL rather than registered from inside each page: pages are lazy-loaded behind a
 * `<Suspense>`, so a page-level opt-out cannot run until its chunk has downloaded, and the
 * announcement would flash on the page in the meantime.
 */
export const isBreakDisplaySuppressedPath = (pathname: string): boolean =>
  SUPPRESSED_ROUTE_PATTERNS.some(
    (pattern) => matchPath({ path: pattern }, pathname) !== null,
  );
